import { render, staticRenderFns } from "./BookingPreview.vue?vue&type=template&id=bc2f3f40&scoped=true&"
import script from "./BookingPreview.vue?vue&type=script&lang=js&"
export * from "./BookingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2f3f40",
  null
  
)

export default component.exports